const entities = require("entities");

function decodeHtml(html) {
	// should be used to decode html entities
	return entities.decodeHTML(html);
}

function unifyListItemWithComma(text) {
	// should be used to unify list items with comma
	// ex: <li>item 1</li><li>item 2</li> -> item 1, item 2
	return text.replace(/<li>/g, ", ");
}

function removeAllTags(text) {
	// should be used to remove all tags
	// ex: <p>text</p> -> text
	return text.replace(/<[^>]*>?/g, " ").trim();
}

function removeWhiteSpace(text) {
	// should be used to remove extra spaces
	// ex: "<s><s>text" -> "<s>text"
	return text.replace(/\s+/g, " ").trim();
}

function removeSpacePrecedingDot(text) {
	// should be used to remove space preceding dot
	// ex: "text . text" -> "text. text"
	return text.replace(/\s*\./g, ".");
}

export function normalizePostContent(text, maxLength) {
	let normalizedPost = removeSpacePrecedingDot(
		removeWhiteSpace(removeAllTags(unifyListItemWithComma(decodeHtml(text)))),
	).trim();

	if (maxLength) {
		normalizedPost = normalizedPost.slice(0, maxLength);
	}

	return `<p>${normalizedPost}</p>`;
}
